import { Brand } from 'common/Brand';
import { useIsTableRunHost } from './useIsTableRunHost';

/**
 * The brand the current page is being served under.
 *
 * Delegates to {@link useIsTableRunHost} rather than `getStorefront` so there is still exactly one
 * host detector behind React-rendered branding. The two disagree — `getStorefront` also honours
 * the native app's injected value and a `?storefront=` param — and a page whose title says one
 * brand while its router serves the other is worse than either answer alone.
 */
export const useBrand = (): Brand => (useIsTableRunHost() ? Brand.TableRun : Brand.Shef);
